import { QueryClient } from '@tanstack/react-query';

// Khởi tạo QueryClient với defaultOptions tối ưu
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 phút cache sống, tránh gọi lại API liên tục
      refetchOnWindowFocus: false, // Tránh refetch không cần thiết khi đổi tab
      retry: 1, // Thử lại tối đa 1 lần nếu gặp sự cố mạng
    },
  },
});
